import { render, staticRenderFns } from "./ErrosDialog.vue?vue&type=template&id=86a85d84"
import script from "./ErrosDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrosDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports